export default __webpack_public_path__ + "static/media/o10.e497fdd0.jpg";